import { inject } from 'mobx-react';
import { ToastComponent } from './component';
export const Toast = inject(({ assistance }) => ({
    notifications: assistance.notifications,
    dismissNotification: assistance.dismissNotification,
}))(ToastComponent);
//# sourceMappingURL=index.js.map